import { render, staticRenderFns } from "./GiftCardIssuanceReport.vue?vue&type=template&id=0aea3df6&scoped=true&"
import script from "./GiftCardIssuanceReport.vue?vue&type=script&lang=js&"
export * from "./GiftCardIssuanceReport.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardIssuanceReport.vue?vue&type=style&index=0&id=0aea3df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea3df6",
  null
  
)

export default component.exports